import { handleSubState, handleAction, handleServerEvent } from 'uix/actions';
import log from 'uix/logging';
import { dict, filterItems, flatten, values, get, mapItems } from 'ldash';
import { loadJobSpec, setJobSpec, setActiveJobs, setActiveJob, jobCreated, updateJobInfo, startJob, setJobEvents } from './actions';
let reduceFilter = (filterName, reducer)=>{
    // custom reducer should have signature (state, filterPayload) => nextState
    // action should be SET_FILTER_DATA
    return (state, { payload })=>{
        let { filterData } = payload;
        let matchedFilters = flatten(values(filterData)).filter((e)=>e[filterName]);
        if (matchedFilters.length > 0) {
            let matchedFilterData = values(matchedFilters[0])[0].data;
            return reducer(state, matchedFilterData);
        }
        //~ return reducer(state, action)
        return state;
    };
};
export const config = [
    handleAction(setJobSpec, (config, { payload })=>({
            ...config,
            jobSpec: payload
        }), {
        jobSpec: {}
    })
];
let mergeJob = (jobs, job)=>[
        ...jobs.filter((j)=>j.ojid !== job.ojid),
        job
    ];
export const data = [
    handleSubState('job', [
        handleServerEvent('EJobStarted', (job, { payload })=>({
                ...job,
                active: mergeJob(job.active, payload)
            })),
        handleServerEvent('EJobFinished', (job, { payload })=>({
                ...job,
                active: job.active.filter((j)=>j.ojid !== payload.ojid),
                seen: mergeJob(job.seen, payload)
            })),
        handleServerEvent('EJobQueued', (job, { payload })=>({
                ...job,
                seen: mergeJob(job.seen, payload)
            })),
        handleAction(setActiveJobs, (job, { payload })=>{
            let { active } = payload;
            let ids = active.map((j)=>j.ojid);
            let missing = job.active.filter((j)=>!ids.includes(j.ojid));
            let seen = [
                ...job.seen,
                ...missing
            ].slice(-100);
            return {
                ...job,
                active,
                seen
            };
        }),
        handleAction(setActiveJob, (job, { payload })=>{
            return {
                ...job,
                active: mergeJob(job.active, payload.job)
            };
        }),
        handleAction(jobCreated, (job, { payload })=>{
            let { history } = job;
            if (history[payload.job.name]) {
                // clear history
                history = dict(filterItems(history, (name)=>name != payload.job.name));
            }
            // push early into job active
            // this is important for non-websocket case
            let active = [
                ...job.active,
                payload.job
            ];
            return {
                ...job,
                active,
                created: [
                    ...job.created,
                    payload.job
                ].slice(-10),
                history
            };
        }),
        handleAction(updateJobInfo, (job, { payload })=>{
            let { jobs } = payload;
            // if there are loaded histories update them
            let jobnames = new Set(jobs.map((j)=>j.name));
            let byOjid = dict(jobs.map((j)=>[
                    j.ojid,
                    j
                ]));
            let histories = filterItems(job.history, (name, histdata)=>jobnames.has(name));
            if (histories.count == 0) {
                // if we have seen a job - run update of data.job.info
                // dont do it unconditionally
                let knownJobInfos = byOjid.filter((ojid)=>job.info[ojid]);
                if (knownJobInfos.length > 0) {
                    let info = {
                        ...job.info,
                        ...byOjid
                    };
                    return {
                        ...data,
                        job: {
                            ...job,
                            info
                        }
                    };
                }
                // nothing updatable
                return data;
            }
            histories = histories.map(([name, histdata])=>{
                // also add newer jobs to histories
                let max_ojid = Math.max(...histdata.map((j)=>j.ojid));
                // beware: ojid key is a string
                let newer = mapItems(jobs, (ojid, j)=>j, (ojid, j)=>j.name == name && j.ojid > max_ojid);
                histdata = histdata.map((j)=>byOjid[j.ojid] || j);
                return [
                    name,
                    [
                        ...newer,
                        ...histdata
                    ]
                ];
            });
            let history = {
                ...job.history,
                ...dict(histories)
            };
            let info = {
                ...job.info,
                ...byOjid
            };
            job = {
                ...job,
                history,
                info
            };
            // if we get jobs with an "ended" timestamp here, also remove them from job.active, the above handlers are not fully reliable
            // and if websockets are offline
            let ended = jobs.filter((j)=>j.state !== 'RUNNING' && j.ended).map((j)=>j.ojid);
            let active_ojids = job.active.map((j)=>j.ojid);
            if (ended.some((ojid)=>active_ojids.includes(ojid))) {
                let active = job.active.filter((j)=>!ended.includes(j.ojid));
                job = {
                    ...job,
                    active
                };
            }
            return job;
        }),
        handleAction(setJobEvents, (job, { payload })=>{
            let { events } = job;
            let { ojid, evdata } = payload;
            return {
                ...job,
                events: {
                    ...events,
                    [ojid]: evdata
                }
            };
        })
    ], // see package local reduceApi calls for reducers of history, ..
    {
        active: [],
        seen: [],
        created: [],
        history: {},
        events: {},
        info: {}
    })
];
